import get from '@/api/base/no-authorization/get';
import addAuthorization from '@/api/base/token/addAuthorization';
/**
 * Make a GET request with authorization.
 * @param {string} url Route path.
 * @param {object} options Request options.
 */
export default async function (url, options = {}) {
    const optionsWithAuth = await addAuthorization(options);
    return get(url, optionsWithAuth);
}
